// extracted by mini-css-extract-plugin
export var chevronIcon = "_89-2";
export var teamName = "_89-1";
export var teamSwitcherButton = "_89-0";